import React, { useState, useEffect } from 'react';
import Styles from './PublicLabView.module.scss';
import ExpandLessIcon from '@mui/icons-material/ExpandLess';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';

export default function LabView({ data }) {
    const [expandedNodeId, setExpandedNodeId] = useState(null);
    const [expandedTimelineNodes, setExpandedTimelineNodes] = useState({});

    useEffect(() => {
        if (data?.nodes?.length) {
            const firstNodeId = data.nodes[0].id;
            setExpandedNodeId(firstNodeId);
            setExpandedTimelineNodes({ [firstNodeId]: false });
        }
    }, [data]);

    return (
        <div id='nodesContainer' className={Styles.nodesContainer}>
            {data?.nodes?.map((node) => {
                const isNodeExpanded = expandedNodeId === node.id;

                return (
                    <div
                        key={node.id}
                        id={`labCard_${node.id}`}
                        className={`${Styles.labCard} ${isNodeExpanded ? Styles.nodeCardExpanded : ''}`}
                    >
                        <div
                            id={`nodeHeader_${node.id}`}
                            className={Styles.nodeHeader}
                            onClick={() => {
                                const isSameNode = expandedNodeId === node.id;
                                const newExpandedId = isSameNode ? null : node.id;
                                setExpandedNodeId(newExpandedId);
                                setExpandedTimelineNodes({ [node.id]: false });
                            }}
                            style={{ cursor: 'pointer' }}
                        >
                            <div id={`nodeIconContainer_${node.id}`} className={Styles.nodeIconContainer}>
                                <img alt={node.name} src={`${process.env.REACT_APP_GLOBAL_MEDIA_URL}${node.icon}`} />
                            </div>
                            <span id={`nodeTitle_${node.id}`} className={Styles.nodeTitle}>{node.name}</span>
                            <button
                                id={`nodeExpandBtn_${node.id}`}
                                className={Styles.expandButton}
                                onClick={(e) => {
                                    e.stopPropagation();
                                    const isSameNode = expandedNodeId === node.id;
                                    const newExpandedId = isSameNode ? null : node.id;
                                    setExpandedNodeId(newExpandedId);
                                    setExpandedTimelineNodes({ [node.id]: false });
                                }}
                            >
                                {isNodeExpanded ? (
                                    <ExpandLessIcon className={Styles.chevronIcon} fontSize="small" />
                                ) : (
                                    <ExpandMoreIcon className={Styles.chevronIcon} fontSize="small" />
                                )}
                            </button>
                        </div>

                        {isNodeExpanded && (
                            <>
                                <ul id={`timelineList_${node.id}`} className={Styles.timelineList}>
                                    {(expandedTimelineNodes[node.id] ? node.steps : node.steps.slice(0, 5))?.map((timeline, index) => (
                                        <li
                                            key={index}
                                            id={`timelineItem_${node.id}_${index}`}
                                            className={Styles.timelineItem}
                                        >
                                            {timeline}
                                        </li>
                                    ))}
                                </ul>

                                {node.steps.length > 5 && (
                                    <button
                                        id={`showMoreBtn_${node.id}`}
                                        className={Styles.showMoreButton}
                                        onClick={(e) => {
                                            e.stopPropagation();
                                            setExpandedTimelineNodes((prev) => ({
                                                ...prev,
                                                [node.id]: !prev[node.id],
                                            }));
                                        }}
                                    >
                                        {expandedTimelineNodes[node.id] ? 'Show Less' : 'Show More'}
                                    </button>
                                )}
                            </>
                        )}
                    </div>
                );
            })}
        </div>
    );
}
